import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';

import { CommonService } from '../services/common.service';
import { StorageService } from '../services/storage.service';
import { AuthenticationService } from 'src/app/authentication/services/authentication.service';
import { Router } from '@angular/router';
import { refreshRequestModel } from 'src/app/authentication/models/refresh';
import { routingAuthenticationModuleType, routingModuleType } from '../enums/module-types';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  private is_refreshing = false;
  private refresh_token_subject: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  refresh_request: refreshRequestModel

  constructor(
    private router: Router,
    private commonService: CommonService,
    private authenticationService: AuthenticationService,
    private storageService: StorageService,
  ) {
    this.refresh_request = new refreshRequestModel();
  }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (request.url.includes('assets')) {
      // If the URL matches the one you want to block, bypass the interceptor
      return next.handle(request);
    }

    if (request.url.includes('restcountries')) {
      // If the URL matches the one you want to block, bypass the interceptor
      return next.handle(request);
    }
    
    // Concatenate the base URL with the request URL
    var modifiedRequest = request.clone({
      url: this.commonService.getBaseURL() + request.url,
    });

    // Add content type to all requests
    if (request.body instanceof FormData) {
      // For requests with FormData, set Content-Type to multipart/form-data
      modifiedRequest = modifiedRequest.clone({
        body: request.body,
      });
    } else {
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          'Content-Type': 'application/json', // Replace with your desired Content-Type
        },
      });
    }

    // Add authorization token to all other requests
      const token = this.storageService.getAccessToken();
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });

    // Pass the modified request to the next interceptor or the HTTP handler
    // return next.handle(modifiedRequest);

    return next.handle(modifiedRequest).pipe(
      catchError((error) => {
        if (error.status === 401) {
          if (error.error.code && error.error.code == 'session_expired') {
            this.storageService.clearLocalStorageInfo();
            this.router.navigate([routingModuleType.authentication, routingAuthenticationModuleType.signin]);
            var error_msg = {
              'error': error.error.detail
            }
            return throwError(() => error_msg);
          } else if (!this.is_refreshing) {
            this.is_refreshing = true;
            this.refresh_token_subject.next(null);

            this.refresh_request.refresh = this.storageService.getRefreshToken();
            console.log('error401')

            return this.authenticationService.refreshToken(this.refresh_request).pipe(
              switchMap((newToken: any) => {
                console.log('newToken')
                this.is_refreshing = false;
                this.refresh_token_subject.next(newToken);
                this.storageService.setLocalStorageTokenInfo(newToken);
                return next.handle(this.addToken(modifiedRequest, newToken));
              }),
              catchError((refreshError) => {
                console.log('refreshError')
                this.storageService.clearLocalStorageInfo();
                this.router.navigate([routingModuleType.authentication, routingAuthenticationModuleType.signin]);
                var error_msg = {
                  'error': 'your login session expired!'
                }
                return throwError(() => error_msg);
              })
            );
          } else {
            return this.refresh_token_subject.pipe(
              filter((newToken) => newToken !== null),
              take(1),
              switchMap((newToken) => {
                return next.handle(this.addToken(modifiedRequest, newToken));
              })
            );
          }
        }
        throw error;
      })
    );
  }

  private addToken(request: HttpRequest<any>, token: any): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token.access}`,
      },
    });
  }
}